import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  RiMagicLine as _RiMagicLine,
  RiTimeLine as _RiTimeLine,
  RiLayoutMasonryLine as _RiLayoutMasonryLine,
  RiArrowLeftLine as _RiArrowLeftLine,
  RiVideoLine as _RiVideoLine,
  RiShieldLine as _RiShieldLine,
  RiQuillPenLine as _RiQuillPenLine,
  RiSmartphoneLine as _RiSmartphoneLine,
  RiChatSmile2Line as _RiChatSmile2Line
} from 'react-icons/ri';
import './Creator.css';
import LightRays from '../../components/common/LightRays/LightRays';
import { useCampaignSettings } from '../../hooks/useCampaignSettings';

const RiSmartphoneLine = _RiSmartphoneLine as any;
const RiChatSmile2Line = _RiChatSmile2Line as any;
const RiMagicLine = _RiMagicLine as any;
const RiTimeLine = _RiTimeLine as any;
const RiLayoutMasonryLine = _RiLayoutMasonryLine as any;
const RiArrowLeftLine = _RiArrowLeftLine as any;
const RiVideoLine = _RiVideoLine as any;
const RiShieldLine = _RiShieldLine as any;
const RiQuillPenLine = _RiQuillPenLine as any;

const CreatorLanding: React.FC = () => {
  const [searchParams] = useSearchParams();
  const fromPortal = searchParams.get('from') === 'portal';
  const { videoEnabled, redditEnabled, settingsLoading } = useCampaignSettings();

  return (
    <div className="creator-landing">
      {fromPortal && (
        <Link to="/portal" className="back-to-portal">
          <RiArrowLeftLine /> Back to Portal
        </Link>
      )}
      <LightRays
        raysOrigin="top-center"
        raysColor="#667EEA"
        raysSpeed={0.6}
        lightSpread={1.5}
        rayLength={2}
        pulsating={true}
        fadeDistance={1.2}
        saturation={0.8}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0.05}
        distortion={0.1}
      />
      <h1 className="creator-landing-title">Creator Tools</h1>

      <div className="tools-grid">
        <Link to={`/creator/quests${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiMagicLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Quests & Routine</h2>
            <p className="tool-description">
              Create countdown templates with ratings and progress circles for social media
            </p>
          </div>
        </Link>

        <Link to={`/creator/screentime${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiTimeLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Screen Time Template</h2>
            <p className="tool-description">
              Simplified rating template to track your app usage and digital health
            </p>
          </div>
        </Link>

        <Link to={`/creator/mix${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiLayoutMasonryLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Mix & Match</h2>
            <p className="tool-description">
              Combine Quests and Screen Time apps seamlessly in a single layout
            </p>
          </div>
        </Link>

        <Link to={`/creator/pov${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiSmartphoneLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">POV Video</h2>
            <p className="tool-description">
              Your character clip cut into the Upshift screen time reveal, exported as a 9:16 MP4
            </p>
          </div>
        </Link>

        <Link to={`/creator/snap${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiChatSmile2Line />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Snap Video</h2>
            <p className="tool-description">
              Upload a video and add Snapchat-style text bars and the digital time sticker
            </p>
          </div>
        </Link>

        {!settingsLoading && videoEnabled && (
        <Link to={`/creator/content${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiVideoLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Video Assets</h2>
            <p className="tool-description">
              Download approved video clips and assets to use in your social media content
            </p>
          </div>
        </Link>
        )}

        {/* <Link to={`/creator/rewrite${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiQuillPenLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Post Rewriter</h2>
            <p className="tool-description">
              Turn an existing Reddit post into a fresh, human-sounding rewrite — same idea, different words
            </p>
          </div>
        </Link> */}

        {!settingsLoading && redditEnabled && (
        <Link to={`/cleaner${fromPortal ? '?from=portal' : ''}`} className="tool-card">
          <div className="tool-icon-wrapper">
            <RiShieldLine />
          </div>
          <div className="tool-info">
            <h2 className="tool-title">Image Metadata Cleaner</h2>
            <p className="tool-description">
              Strip metadata and apply imperceptible transforms to your Reddit screenshots so they aren't flagged
            </p>
          </div>
        </Link>
        )}
      </div>
    </div>
  );
};

export default CreatorLanding;
